<template>
  <div class="social-share">
    <h4 v-if="headerText" class="social-share__header-text">
      {{ headerText }}
    </h4>
    <ul class="social-share__icons">
      <li v-for="(platform, key) in platforms"
          :key="key"
          class="social-share__list-item">
        <a
            :href="getShareUrl(platform)"
            target="_blank"
            rel="noopener noreferrer"
            :title="`Share on ${platform.name}`"
            class="social-share__btn">
          <img
              :src="platform.icon"
              :alt="`Share on ${platform.name}`"
              class="social-share__icon"
          />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import IconFacebook from '~/assets/icons/IconShareFacebookColoured.png';
import IconTwitter from '~/assets/icons/IconShareXColoured.png';
import IconLinkedin from '~/assets/icons/IconShareLinkedInColoured.png';
import IconInstagram from '~/assets/icons/IconShareInstaColoured.png';
import { useRoute } from '#imports';

export default {
  name: 'SocialShare',
  props: {
    headerText: String
  },
  mounted() {
    const route = useRoute()
    this.url = window.location.origin + route.fullPath
  },
  data() {
    return {
      url: '',
      platforms: {
        twitter: {
          name: 'X',
          icon: IconTwitter,
          shareUrl: (url) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
        },
        facebook: {
          name: 'Facebook',
          icon: IconFacebook,
          shareUrl: (url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
        },
        linkedin: {
          name: 'LinkedIn',
          icon: IconLinkedin,
          shareUrl: (url) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
        },
        instagram: {
          name: 'Instagram',
          icon: IconInstagram,
          shareUrl: (url) => `https://www.instagram.com/share/url/?url=${encodeURIComponent(url)}`,
        }
      },
    };
  },
  methods: {
    getShareUrl(platform) {
      return platform.shareUrl(this.url)
    },
  },
};
</script>

<style lang="scss">
@use "~/common/scss/helpers";

.social-share {

  &__header-text {
    margin-bottom: 1rem;
  }

  &__icon {
    margin: 1.1rem 0 0 .1rem;
    width: 24px;
    border: 1px solid black;
    border-radius: 50%;
  }

  &__icons {
    align-items: center;
    display: flex;
    gap: helpers.px-to-rem(8);
    list-style: none;
    padding: 0 0 !important;
  }

  &__list-item {
    height: 100%;
  }

  &__btn {
    align-items: center;
    color: var(--share-color, #444);
    display: inline-flex;
    font-size: var(--share-size, 1.5rem);
    height: 1em;
    line-height: 1em;
    text-decoration: none;
    transition: color .25s;
    width: 1em;

    &:hover {
      color: var(--share-color-hover, #000);
    }

    svg {
      height: 1em;
      width: 1em;
    }
  }
}

.ss_social_share-wrapper {
  width: fit-content;
  margin: 1.2rem auto .8rem auto;
}
</style>
  